import { Grid, makeStyles } from '@material-ui/core';
import {useCallback, useEffect} from 'react';
import {
  Label as LabelIcon,
  DynamicFeed as DynamicFeedIcon,
} from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import QCXFocusLock from "../../../components/focus-lock/QCXFocusLock";
import QCXMainLayout from "../../../components/main-layout/QCXMainLayout";
import QCXCardMenu from '../../../shared-components/card-menu/QCXCardMenu';
import { setHouseHawbType, setHouseHblType, setOperationExportacao as setOperationExportacaoHouse  } from '../../../features/house/HouseSlice';
import { setBlType, setMasterType, setOperationExportacao as setOperationExportacaoMaster } from '../../../features/master/masterSlice';


const useStyles = makeStyles((theme) => ({
  cardMenuContainer: {
    marginTop: theme.spacing(0),
  },
  cardMenu: {
    width: theme.spacing(100),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  subNested: {
    paddingLeft: theme.spacing(8),
  },
  active: {
    display: 'flex!important',
  },
  noActive: {
    display: 'none!important',
    transformOrigin: '0 0 0!important',
  },
}));

export default function AgenciamentoExportacaoPageAereo({ authInfo = {} }) {

  const { t } = useTranslation();
  const classes = useStyles();

  const dispatch = useDispatch();

  const breadcrumbs = [
    {
      link: {
        to: '/',
        name: t('com.muralis.qcx.inicio'),
      },
    },
    {
      text: {
        name: 'Agenciamento Aéreo Exportação',
      },
    }
  ];

  dispatch(setOperationExportacaoMaster());
  dispatch(setOperationExportacaoHouse());

  const userHasAnyRole = useCallback((mainRoles = []) => (
    authInfo?.roles?.some((role) => mainRoles?.find((item) => role?.startsWith(item)))
  ), [authInfo]);


  return (
    <>
      <QCXMainLayout
        pageIcon={<LabelIcon />}
        pageTitle='Agenciamento Aéreo Exportação'
        breadcrumbs={breadcrumbs}
        authInfo={authInfo}
      >
        <Grid className={classes.cardMenuContainer} item container justify="center" xs={12} sm={12} md={12} xl={12}>
          <QCXFocusLock>
            <Grid container style={{ maxWidth: '1920px' }}>
              
              {userHasAnyRole(['agenciamento-exportacao-aereo']) && (
                <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                  <QCXCardMenu
                    title="Follow Up"
                    link='/exportacao/agenciamento/aereo/follow-up'
                    icon={DynamicFeedIcon}
                    timeout={3000}
                    onClick={() => {
                      dispatch(setHouseHblType());
                    }}
                  />
                </Grid>
              )}

              {userHasAnyRole(['agenciamento-exportacao-aereo']) && (
                <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                  <QCXCardMenu
                    title={t('com.muralis.qcx.master.title')}
                    link='/exportacao/agenciamento/aereo/master'
                    icon={DynamicFeedIcon}
                    timeout={3000}
                    onClick={() => {
                      dispatch(setMasterType());
                    }}
                  />
                </Grid>
              )}

              {userHasAnyRole(['agenciamento-exportacao-aereo']) && (
                <Grid item justify="center" xs={6} sm={4} md={3} lg={3} xl={2} className={classes.active}>
                  <QCXCardMenu
                    title="HAWB"
                    link='/exportacao/agenciamento/aereo/hawb'
                    icon={DynamicFeedIcon}
                    timeout={3000}
                    onClick={() => {
                      dispatch(setHouseHawbType());
                    }}
                  />
                </Grid>
              )}
              
            </Grid>
          </QCXFocusLock>
        </Grid>

      </QCXMainLayout>
    </>
  );
}
